import React from 'react';
import styles from './field-line.scss';

type Props = {
  defaultColor?: string;
  open?: boolean;
  style?: Object;
};

export default ({ defaultColor, open, style }: Props) =>
  <div className={styles.holder} style={{ backgroundColor: defaultColor, ...style }}>
    <div className={styles.highlight} style={{ width: open ? '100%' : 0 }} />
  </div>
;
